module.exports = __webpack_public_path__ + "static/media/Joy_of_contribution.f0c76803.svg";